import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { GenderStats } from '../../../service/coursera-dashboard-stats.model';
import { Chart, ChartConfiguration, ChartData, ChartOptions } from 'chart.js';

@Component({
  selector: 'app-coursera-genre-chart',
  templateUrl: './coursera-genre-chart.component.html',
  styleUrls: ['./coursera-genre-chart.component.css'],
})
export class CourseraGenreChartComponent implements OnChanges {
  @Input() data: GenderStats[] = [];
  @ViewChild('genreChart') chartRef!: ElementRef;

  chart!: Chart;

  ngOnChanges(): void {
    // 🔥 si pas de données → on sort (noData côté HTML)
    if (!this.data || this.data.length === 0) return;

    // 🔥 attendre que le canvas soit rendu (ngIf)
    setTimeout(() => {
      this.createChart();
    });
  }

  createChart() {
    if (!this.chartRef?.nativeElement) return;

    const ctx = this.chartRef.nativeElement.getContext('2d');

    const labels = this.data.map((d) => d.genre);
    const values = this.data.map((d) => d.total);

    // 🔥 détruire ancien chart si existant
    if (this.chart) {
      this.chart.destroy();
    }

    const config: ChartConfiguration = {
      type: 'pie',
      data: {
        labels,
        datasets: [
          {
            data: values,
          },
        ],
      },
      options: {
        responsive: true,
      },
    };

    this.chart = new Chart(ctx, config);
  }
}
